var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ethereum",
    transform: "translate(-801 -700)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 28,
    height: 28,
    transform: "translate(801 700)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_ethereum_1362105",
    transform: "translate(788.186 701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(18.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M18.821,13.47a.405.405,0,0,0,.034.154.309.309,0,0,0,.022.048.4.4,0,0,0,.135.143h0l0,0,7.934,4.649c.006,0,.013,0,.02.006a.413.413,0,0,0,.19.051.4.4,0,0,0,.19-.052.212.212,0,0,0,.022-.006l7.793-4.649a.409.409,0,0,0,.138-.145.315.315,0,0,0,.022-.047.413.413,0,0,0,.035-.154c0-.011.007-.021.007-.032s0-.009-.005-.014a.4.4,0,0,0-.053-.177L27.518.2c0-.005-.008-.007-.011-.013a.331.331,0,0,0-.032-.04A.473.473,0,0,0,27.428.1a.4.4,0,0,0-.038-.03c-.005,0-.008-.009-.013-.012a.3.3,0,0,0-.028-.01.39.39,0,0,0-.056-.023.352.352,0,0,0-.051-.015A.29.29,0,0,0,27.19.006.257.257,0,0,0,27.162,0c-.01,0-.017,0-.027.005a.434.434,0,0,0-.05.005.413.413,0,0,0-.055.016.379.379,0,0,0-.056.023c-.008,0-.018,0-.026.009s-.008.008-.012.011A.394.394,0,0,0,26.9.1a.433.433,0,0,0-.046.045.4.4,0,0,0-.03.038c0,.005-.009.008-.013.013L18.874,13.246a.4.4,0,0,0-.055.179c0,.005,0,.009,0,.014S18.821,13.459,18.821,13.47ZM27.577,1.917l6.337,10.609L27.577,9.62Zm-.829,7.7-6.469,2.915L26.748,1.895Zm0,.91v6.857l-6.616-3.876Zm.829,6.85V10.532l6.488,2.977Z",
    transform: "translate(-18.814)",
    fill: "#366eef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M35.523,55.47a.419.419,0,0,0-.516-.076l-7.656,4.52L19.7,55.394a.415.415,0,0,0-.55.6l7.864,11.08c.006.009.016.011.022.019a.424.424,0,0,0,.051.053c.009.007.014.019.024.026s.018,0,.026.009.025.019.039.026a.4.4,0,0,0,.174.042h0a.4.4,0,0,0,.174-.042.459.459,0,0,0,.039-.026c.008-.006.018,0,.026-.009s.015-.018.024-.026a.4.4,0,0,0,.051-.053c.006-.008.017-.01.022-.019l7.867-11.08A.414.414,0,0,0,35.523,55.47Zm-8.586,5.164v4.9L20.952,57.1Zm.829,4.9v-4.9L33.753,57.1Z",
    transform: "translate(-19.003 -40.583)",
    fill: "#366eef"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.b0046f303565d59d7dd6cf7e136d6fd5.svg";
export { ForwardRef as ReactComponent };